export const SIZE = {
  threeByThree: '3x3',
  fourByFour: '4x4'
};
